export function orderCatalogue(items, order) {
    const list = Array.isArray(items) ? items : [];
    if (!Array.isArray(order) || order.length === 0)
        return list;
    const rank = new Map();
    for (const id of order) {
        if (typeof id === "string" && !rank.has(id))
            rank.set(id, rank.size);
    }
    const ranked = list
        .filter((i) => rank.has(i.id))
        .sort((a, b) => rank.get(a.id) - rank.get(b.id));
    const rest = list.filter((i) => !rank.has(i.id));
    return [...ranked, ...rest];
}
export function reorderIds(ids, activeId, overId) {
    if (!Array.isArray(ids) || activeId === overId)
        return null;
    const from = ids.indexOf(activeId);
    const to = ids.indexOf(overId);
    if (from < 0 || to < 0)
        return null;
    const next = [...ids];
    next.splice(to, 0, next.splice(from, 1)[0]);
    return next;
}
